import { Component, OnInit, Input, OnChanges, SimpleChange, EventEmitter, Output } from '@angular/core';
import { TiendaService } from 'app/_services/tienda.service';
import { GlobalEventsManager } from 'app/_services/globaleventsmanager.service';
import { ConfirmationService } from 'primeng/primeng';


declare var jQuery: any;


@Component({
  selector: 'usuariorolesapps',
  templateUrl: './usuariorolesapps.component.html',
  styleUrls: ['./usuarioroles.component.css']
})
export class UsuariorolesappsComponent implements OnInit, OnChanges {

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  listaApps: any = [];

  mostrarConfirmActualizar:boolean = false;

  constructor(private tiendaService: TiendaService,
              private globalEventsManager: GlobalEventsManager,
              private confirmationService: ConfirmationService) 
              { }

  @Input() _idRole: any;
  @Output() onCloseRoleApps = new EventEmitter<number>();


  ngOnInit() {


  }


  ngOnChanges(changes: { [propName: string]: SimpleChange }) {

    if (changes['_idRole']) {
      this._idRole = changes['_idRole'].currentValue;
      this.getTiendaAplicaciones();
    }


  }

  getTiendaAplicaciones() {

    let dataStore: any;
    this.tiendaService.getTiendaAplicaciones(this._idRole).subscribe(
      data => {
        dataStore = data.json().lista;

      },
      err => { },
      () => {
        this.listaApps = dataStore;
        console.log(this.listaApps);
      }
    )

  }

  modificarPermiso(item: any, id_permiso: number) {

    if (jQuery('#check_permiso_' + id_permiso).is(':checked')) {
      item.permiso = 1;
    } else {
      item.permiso = 0;
    }

    if (item.permiso == 1) {
      this.tiendaService.setUserRoleApp(this._idRole, item.id_app).subscribe(
        data => {
          if (data) {

            let al: any = {
              "texto": "Permiso guardado",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);


          }
        }
      )
    } else {
      this.tiendaService.deleteUserRoleApp(this._idRole, item.id_app).subscribe(
        data => {
          if (data) {

            let al: any = {
              "texto": "Permiso guardado",
              "mostrar": true
            };
            this.globalEventsManager.setAlert(al);


          }
        }
      )
    }
  }

  cerrar(destino: number) {

    this.onCloseRoleApps.emit(destino);
  }


  confirmActualizarUsuariosRole() {
    this.mostrarConfirmActualizar = true;

    this.confirmationService.confirm({
      message: '¿Seguro que deseas actualizar el role a todos los usuarios?',
      accept: () => {
            this.actualizarUsuarios();
      },
      reject: () => { 

        this.mostrarConfirmActualizar = false;

        }
    });
  }

  actualizarUsuarios() {
    this.tiendaService.actualizarUsuariosRoleApps(this._idRole).subscribe(
      data => {
        if (data) {
          this.mostrarConfirmActualizar = false;
          let al: any = {
            "texto": "Usuarios actualizados",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarioroles/usuariorolesapps.component.ts